import { render, staticRenderFns } from "./GroupPlate.vue?vue&type=template&id=5b0baa0a&"
import script from "./GroupPlate.vue?vue&type=script&lang=ts&"
export * from "./GroupPlate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports